module.exports = __webpack_public_path__ + "img/spriteimg02.e0d59bfb.png";